import { html } from '@design.estate/dees-element';
import { demoPage, demoOutput, showDemoResult } from '../../../demos/templates.js';

import type {
  IHarnessIntelligenceExchange,
  IHarnessScratchpad,
  IHarnessSessionMetrics,
  IHarnessTodoItem,
} from '../interfaces.js';

const todos: IHarnessTodoItem[] = [
  { content: 'Inspect current context usage', status: 'completed' },
  { content: 'Verify the cache-key patch', status: 'in_progress' },
  { content: 'Prepare the release', status: 'pending' },
];

const metrics: IHarnessSessionMetrics = {
  lifetimeUsedTokens: 184_320,
  compactionCount: 2,
  tokensBeforeLatestCompaction: 112_840,
  currentContextTokens: 47_200,
  maxContextTokens: 128_000,
};

const scratchpad: IHarnessScratchpad = {
  id: 'demo-session',
  text: '- Cache keys use the route manifest hash.\n- Release after staging verification.',
  revision: 4,
  updatedAt: Date.now() - 45_000,
  updatedBy: 'intelligence',
};

const exchanges: IHarnessIntelligenceExchange[] = [{
  id: 'intelligence-1',
  question: 'What remains before release?',
  answer: 'Staging verification is the only remaining task.',
  status: 'completed',
  model: 'gpt-5.6-luna',
  createdAt: Date.now() - 30_000,
  completedAt: Date.now() - 28_000,
}];

export const demoFunc = () => demoPage('Session details', 'Tasks, context usage, scratchpad and session intelligence alongside a conversation.', html`
  <style>
    .harnessSessionSidebarDemo {
      width: min(100%, 300px);
      height: 640px;
      overflow: hidden;
      border-radius: var(--dees-radius-xl);
      border: 1px solid var(--dees-color-border-subtle);
      background: var(--dees-color-bg-canvas);
    }
  </style>
  <div class="harnessSessionSidebarDemo">
    <dees-harness-session-sidebar
      .todos=${todos}
      .metrics=${metrics}
      .scratchpad=${scratchpad}
      .intelligenceEnabled=${true}
      .intelligenceExchanges=${exchanges}
      @harness-scratchpad-save=${(event: CustomEvent) => {
        showDemoResult((event.currentTarget as Element).parentElement!, event.detail);
      }}
      @harness-session-intelligence-ask=${(event: CustomEvent) => {
        showDemoResult((event.currentTarget as Element).parentElement!, event.detail);
      }}
    ></dees-harness-session-sidebar>
  </div>
  ${demoOutput()}
`);
